import React, { useEffect, useState } from "react";
import { Button, Form, Input, Card, message } from "antd";
import axios from "axios";
import consts from "../../constant";
import Loadingpage from "../Loadingpage/Loadingpage";
const UpdownSetting = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [initialValues, setInitialValues] = useState(null);

  const currentValues = Form.useWatch([], form);

  const isSame = initialValues && currentValues &&
    currentValues.duration === initialValues.duration &&
    Number(currentValues.adminCommission) === Number(initialValues.adminCommission) &&
    Number(currentValues.maximumPairs) === Number(initialValues.maximumPairs);

  const fetchSettings = async () => {
    try {
      const { data } = await axios.post(`${consts.BackendUrl}/getTradeSettings`, { type: 'upDown' }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      if (data?.success && data?.result?.upDown) {
        const values = {
          duration: data.result.upDown.duration,
          adminCommission: data.result.upDown.adminCommission,
          maximumPairs: data.result.upDown.maximumPairs,
        };
        form.setFieldsValue(values);
        setInitialValues(values);
      }
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      await axios.post(`${consts.BackendUrl}/tradeSettings`, {
        type: 'upDown',
        data: {
          duration: values.duration,
          adminCommission: Number(values.adminCommission),
          maximumPairs: Number(values.maximumPairs),
        }
      }, {
        headers: { Authorization: `Bearer ${window.localStorage.getItem("Jetix")}` }
      });
      messageApi.open({ type: "success", content: "UpDown settings updated successfully" });
      fetchSettings();
    } catch (error) {
      messageApi.open({
        type: "error",
        content: error.response?.data?.message || "Failed to update settings"
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div style={{ maxHeight: "80vh", overflow: "hidden" }}>
        <Loadingpage />

        {contextHolder}
        <div
          className="display-2 p-10"
          style={{
            display: "flex",
            gap: "10px",
            alignItems: "center",
            flexWrap: "wrap",
          }}
        >
          <h2>Updown Settings</h2>
        </div>

        <div style={{ marginTop: "40px" }}>
          <div
            className="card-clr"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "60vh",
            }}
          >
            <Card
              style={{
                width: "100%",
                maxWidth: 500,
                padding: "15px  20px",
              }}
            >
              <Form
                form={form}
                name="updown_basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                labelAlign="left"
                style={{ display: "flex", flexDirection: "column" }}
                onFinish={onFinish}
                autoComplete="off"
              >
                <Form.Item label="Duration" name="duration">
                  <Input
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>

                <Form.Item label="Admin Commission " name="adminCommission">
                  <Input
                    style={{ width: "100%" }}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
                <Form.Item label="Maximum Pair " name="maximumPairs">
                  <Input
                    style={{ width: "100%" }}
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>

                <Form.Item style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    type={isSame ? "default" : "primary"}
                    htmlType="submit"
                    loading={loading}
                    danger={isSame}
                    disabled={isSame}
                    style={
                      isSame
                        ? {
                          backgroundColor: "#ff4d4f",
                          borderColor: "#ff4d4f",
                          color: "#fff",
                        }
                        : {}
                    }
                  >
                    {/* {isSame ? "Same value" : "Update"} */}
                    Update
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdownSetting;
